<script lang="ts">
    import { _ } from 'svelte-i18n';

    import type { ApiFilterBuilder } from '@automapa/svelte-automapa-template';
    import IconDropup from './Icons/IconDropup.svelte';
    import IconDropdown from './Icons/IconDropdown.svelte';

    export let jobFilter: ApiFilterBuilder;
    export let onFilterChange: () => void;
    export let label: string;
    export let className: string;
    export let fieldName: string | string[];
    export let disabled: boolean = false;

    let fieldNameStr: string = typeof fieldName === 'string' ? fieldName : fieldName.join(',');

    function getStyle(direction: string, jobFilter: ApiFilterBuilder) {
        let addOpacity = 'opacity: 0.3';
        if (jobFilter.getSortBy()?.field !== fieldNameStr) {
            return addOpacity;
        }
        if (jobFilter.getSortBy()?.direction === direction) {
            addOpacity = 'opacity: 1';
        }
        return addOpacity;
    }

    function getDir(dir: string) {
        // if fieldName is an array, then it is a composite field - return asc/desc for each word joined by comma
        if (typeof fieldName === 'string') {
            return dir;
        } else {
            return fieldName.map(() => dir).join(',');
        }
    }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<div
    class="{className} column-sortable-2"
    style="min-width: 22px;min-height: 31px;"
    title={label}
    class:column-sortable-2-enabled={!disabled}
    data-sortBy={JSON.stringify(jobFilter.getSortBy())}
    data-field={jobFilter.getSortBy()?.field}
    data-fieldName={fieldName}
    data-sortByDir={jobFilter.getSortBy()?.direction}
    on:click={() => {
        if (disabled) {
            console.log('Sorting disabled');
            return false;
        }
        jobFilter.toggleSortBy(fieldName);
        jobFilter = jobFilter;
        onFilterChange();
    }}
>
    {#if label}
        <div class="label">
            {$_(label)}
        </div>
    {/if}
    {#if !disabled}
        <div style="display:flex; flex-direction: column; position:relative; min-width: 14px;
left: -5px;">
            <div style="position: absolute; top: -18px;">
                <IconDropup scale={0.9} style={getStyle(getDir('asc'), jobFilter)} />
            </div>
            <div style="position: absolute; top: -10px;">
                <IconDropdown scale={0.9} style={getStyle(getDir('desc'), jobFilter)} />
            </div>
        </div>
    {/if}
</div>

<style>
    .column-sortable-2 {
        border-radius: 3px;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding-bottom: 4px;
        padding-top: 4px;
        padding-left: 2px;
    }

    .column-sortable-2-enabled:hover {
        cursor: pointer;
        background-color: var(--main-selected-background);
        transition: 0.2s;
    }
    .column-sortable-2 .label {
        flex: 0 1 auto;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
</style>
